<div class="card">
    <p-table [value]="parcelas" styleClass="p-datatable-gridlines">
      <ng-template pTemplate="header">
        <tr>
          <th>Número</th>
          <th>Parcela</th>
          <th>Referência</th>
          <th>Valor Total</th>
          <th>Valor Aprovado</th>
          <th>Última Tramitação</th>
          <th>Estado Atual</th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-parcela>
        <tr>
          <td>{{ parcela.numero }}</td>
          <td>{{ parcela.parcela }}</td>
          <td>{{ parcela.referencia }}</td>
          <td>{{ parcela.valorTotal == null ? 'R$ 0,00' : parcela.valorTotal.toLocaleString('pt-br', { style: 'currency', currency: 'BRL' }) }}</td>
          <td>{{ parcela.valorLiberado == null ? 'R$ 0,00' : parcela.valorLiberado.toLocaleString('pt-br', { style: 'currency', currency: 'BRL' }) }}</td>
          <td>{{ parcela.dataUltimaTramitacao | date: 'dd/MM/yyyy HH:mm' }}</td>
          <td>{{ parcela.estadoAtual }}</td>
        </tr>
      </ng-template>
    </p-table>
  </div>